/* eslint-disable no-case-declarations */
import actions from "./actions";

const {
  GET_STATISTICS_DETAILS_BEGIN,
  GET_STATISTICS_DETAILS_SUCCESS,
  GET_STATISTICS_DETAILS_ERR,
} = actions;

const initState = {
  loadingGetStatisticsDetails: false,
  errorGetStatisticsDetails: null,
  statisticsDetails: {},
};

const statisticsReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_STATISTICS_DETAILS_BEGIN:
      return {
        ...state,
        statisticsDetails: {},
        loadingGetStatisticsDetails: true,
        errorGetStatisticsDetails: null,
      };
    case GET_STATISTICS_DETAILS_SUCCESS:
      return {
        ...state,
        statisticsDetails: data,
        loadingGetStatisticsDetails: false,
        errorGetStatisticsDetails: null,
      };
    case GET_STATISTICS_DETAILS_ERR:
      return {
        ...state,
        statisticsDetails: {},
        loadingGetStatisticsDetails: false,
        errorGetStatisticsDetails: err,
      };

    default:
      return state;
  }
};

export { statisticsReducer };
